function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12.5,
  r: 12.5,
  fill: "#E2E2E3"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.78662 7.25415H11.0716L9.43616 9.03826L13.2141 13.1674V19.7195H11.7858V13.8063L8.42205 10.1446L6.78662 11.9287V7.25415ZM15.5637 9.03826L13.9283 7.25415H18.2132V11.9287L16.5778 10.1446L14.521 12.3883L13.5069 11.282L15.5637 9.03826Z",
  fill: "#979797"
});
const SvgSplitIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgSplitIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/split-icon.1552dbde.svg";
export { ForwardRef as ReactComponent };